import { useEffect, useRef } from "react";
import { createEvent } from "core/utils/tracker";
import analytics from "core/utils/analytics";

/** События просмотра — только когда карточка стала active (не на preload) */
export default function useShortyViewAnalytics({ content, active, viewId }) {
  const trackedContentIdsRef = useRef(new Set());

  useEffect(() => {
    if (!active || !viewId || !content?.id) return;

    if (trackedContentIdsRef.current.has(content.id)) {
      return;
    }

    trackedContentIdsRef.current.add(content.id);

    createEvent(content.type.toLowerCase(), "start");
    analytics.event({
      category: "User",
      action: "Create view",
      label: content.title,
    });
  }, [active, viewId, content]);
}
